export function updateAllPaymentMethods(state, { paymentMethods }) {
  state.all = paymentMethods;
}
